import { useEditorStore } from '@modules/editor';
import { updateMultipleElements } from '@modules/editor/src/lib/element';

import { useCustomEditorStore } from '$/stores/useCustomEditorStore';

export const getComponentBaseLayer = (componentIndex: number): number => {
  return (componentIndex + 1) * 1000;
};

export const getGlobalMaxLayer = (): number => {
  const elements = useEditorStore.getState().elements;

  const maxLayer = Math.max(
    1,
    ...Array.from(elements.values())
      .filter((el) => el.layer > 0)
      .map((el) => el.layer),
  );

  return maxLayer;
};

export const getNextLayerForComponent = (componentId: string): number => {
  const components = useCustomEditorStore.getState().components;
  const componentIndex = components.findIndex((c) => c.id === componentId);

  if (componentIndex === -1) return getGlobalMaxLayer() + 1;

  const baseLayer = getComponentBaseLayer(componentIndex);
  const component = components[componentIndex];
  const elements = useEditorStore.getState().elements;

  const componentElements = Array.from(elements.values()).filter((el) =>
    component.elements.includes(el.id),
  );

  const layersInComponent = componentElements.map((el) => el.layer);

  if (layersInComponent.length === 0) return baseLayer + 1;

  const nextLayer = Math.max(...layersInComponent) + 1;

  if (nextLayer >= baseLayer + 1000) return baseLayer + 999;

  return nextLayer;
};

export const getComponentBaseLayerById = (componentId: string): number => {
  const components = useCustomEditorStore.getState().components;
  const componentIndex = components.findIndex((c) => c.id === componentId);

  if (componentIndex === -1) return 1;

  return getComponentBaseLayer(componentIndex);
};

export const reassignComponentLayers = (componentId: string) => {
  const components = useCustomEditorStore.getState().components;
  const componentIndex = components.findIndex((c) => c.id === componentId);

  if (componentIndex === -1) return;

  const component = components[componentIndex];
  const elements = useEditorStore.getState().elements;
  const componentElements = Array.from(elements.values()).filter((el) =>
    component.elements.includes(el.id),
  );

  const baseLayer = getComponentBaseLayer(componentIndex);

  const sortedElements = componentElements.toSorted(
    (a, b) => a.layer - b.layer,
  );

  updateMultipleElements(
    elements,
    sortedElements,
    sortedElements.map((_, index) => ({
      layer: baseLayer + index,
    })),
  );
};

export const reassignAllComponentLayers = () => {
  const components = useCustomEditorStore.getState().components;
  components.forEach((component) => {
    reassignComponentLayers(component.id);
  });
};
